export default __webpack_public_path__ + "static/media/0.1ab0c31b.jpg";